module.exports = __webpack_public_path__ + "static/Ubuntu-MediumItalic-0fbe070c207e3a869cc9e02f234f81e5.ttf";